import {useState, useCallback} from 'react';
import {useNotifications} from '../lib';

type ErrorInfo = {
  title: string;
  message: string;
};

type ErrorHandlerOptions = {
  resourceName?: string;
  title?: string;
  onRetry?: () => void;
};

export const useErrorHandler = (options: ErrorHandlerOptions = {}) => {
  const {onRetry, title = 'Ошибка соединения'} = options;
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const [errorInfo, setErrorInfo] = useState<ErrorInfo>({title: '', message: ''});
  const {createNotification} = useNotifications();

  const handleError = useCallback(
    (error: ApiError) => {
      const {status, detail, errors} = error;
      if (status >= 500) {
        createNotification({
          theme: 'danger',
          title: 'Что-то пошло не так',
          name: `server-error`,
        });
      } else if (status === 404) {
        createNotification({
          theme: 'danger',
          title: 'Ресурс не найден',
          name: `server-error`,
        });
      } else {
        // Для других ошибок открываем модальное окно
        setErrorInfo({
          title: title,
          message: errors ? Object.values(errors).flat().join('\n') : detail || 'Попробуйте еще раз позднее',
        });
        setIsErrorModalOpen(true);
      }
    },
    [createNotification, title],
  );

  const handleRetry = useCallback(() => {
    setIsErrorModalOpen(false);
    if (onRetry) {
      onRetry();
    }
  }, [onRetry]);

  const handleClose = () => {
    setIsErrorModalOpen(false);
  };

  return {
    isErrorModalOpen,
    setIsErrorModalOpen,
    errorInfo,
    handleError,
    handleRetry,
    handleClose,
  };
};
